import * as React from "react";
import { SVGProps } from "react";
const SvgFilter = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M27 15h-3.1c-.6-2.1-2.8-3.4-4.9-2.8-1.4.4-2.4 1.4-2.8 2.8H5c-.6 0-1 .4-1 1s.4 1 1 1h11.1c.6 2.1 2.8 3.4 4.9 2.8 1.4-.4 2.4-1.4 2.8-2.8H27c.6 0 1-.4 1-1s-.4-1-1-1Zm-7 3c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2Zm7 6h-8.1c-.6-2.1-2.8-3.4-4.9-2.8-1.4.4-2.4 1.4-2.8 2.8H5c-.6 0-1 .4-1 1s.4 1 1 1h6.1c.6 2.1 2.8 3.4 4.9 2.8 1.4-.4 2.4-1.4 2.8-2.8H27c.6 0 1-.4 1-1s-.4-1-1-1Zm-12 3c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2ZM5 8h3.1c.6 2.1 2.8 3.4 4.9 2.8 1.4-.4 2.4-1.4 2.8-2.8H27c.6 0 1-.4 1-1s-.4-1-1-1H15.9c-.6-2.1-2.8-3.4-4.9-2.8-1.4.4-2.4 1.4-2.8 2.8H5c-.6 0-1 .4-1 1s.4 1 1 1Zm7-3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgFilter;
